import { render, staticRenderFns } from "./ScreenTimeManagementModePicker.vue?vue&type=template&id=663de9c0&scoped=true&"
import script from "./ScreenTimeManagementModePicker.vue?vue&type=script&lang=js&"
export * from "./ScreenTimeManagementModePicker.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTimeManagementModePicker.vue?vue&type=style&index=0&id=663de9c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663de9c0",
  null
  
)

export default component.exports